module.exports = __webpack_public_path__ + "static/media/blonde.27cbfbeb.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/alset-reactgame-test/commonGameAssets/characters/blonde.png
// module id = 436
// module chunks = 0